import GlobalSearchResultList from "./GlobalSearchResultList";
import GlobalSearchResultListV1 from "./GlobalSearchResultListV1";

export default GlobalSearchResultList;
export { GlobalSearchResultListV1 };
